import { Locale } from "../../../utils";

const i18n = Locale.getInstance();
export default [
  {
    href: "/main/shop/list",
    title: i18n.t("tuangou.shop"),
  },
];
